export default __webpack_public_path__ + "static/media/right.9fa31c1b.jpg";